import { apiClient } from '@/lib/api-client';
import {
  businessListSchema,
  businessSchema,
  type Business,
  type BusinessSummary,
} from '@/lib/schemas/business';

export const businessApi = {
  get: (slug: string, signal?: AbortSignal): Promise<Business> =>
    apiClient.get(`/businesses/${slug}`, businessSchema, signal ? { signal } : {}),

  search: (query: Record<string, string>, signal?: AbortSignal): Promise<BusinessSummary[]> =>
    apiClient.get('/businesses', businessListSchema, {
      query,
      ...(signal ? { signal } : {}),
    }),
};
